import $http from './http'
import config from './config'

export default {
    name:'mall',
    getUrl(url) {
        return config.getUrl(this.name, url);
    },
    getOrderList(data) {
        return $http.post(this.getUrl(`/mallorder/List`), data);
    },
    OrderUnLock(id) {
        return $http.get(this.getUrl(`/mallorder/OrderUnLock?UniqueID=${id}`));
    },
    OrderLock(id) {
        return $http.get(this.getUrl(`/mallorder/OrderLock?UniqueID=${id}`));
    },
    ConfirmOrderPrice(data) {
        return $http.post(this.getUrl(`/mallorder/ConfirmOrderPrice`), data)
    },
    UpdateOrderStatus(id) {
        return $http.get(this.getUrl(`/mallorder/UpdateOrderStatus?UniqueID=${id}`));
    },
    OrderResolve(data) {
        return $http.post(this.getUrl(`/mallorder/OrderResolve`), data);
    },
}


// WEBPACK FOOTER //
// ./src/apis/mallApis.js